import http from '@/utils/http'
export const getlog = data => http.get('kg-log-center/api/apilog', {
    params: data
})
export default {
    getlog
}